import Dialog from 'react-toolbox/lib/dialog/Dialog'

export default Dialog



// WEBPACK FOOTER //
// ./client/modules/ui/components/Dialog/index.js